/*
 * We're exporting the list of routes from this file instead of
 * the index due to issues with testing
 */

export const routes = {
  agricultural           : '/agricultural/',
  agLineOfCredit         : '/agricultural/line-of-credit/',
  agPurchaseEquipment    : '/agricultural/purchase-equipment/',
  agRefinanceProperty    : '/agricultural/refinance-property/',
  agPurchaseAcreage      : '/agricultural/purchase-acreage/',
  application            : '/application/',
  applicationConstruction : '/application/construction/',
  applicationHomeEquity  : '/application/home-equity/',
  applicationLand        : '/application/land/',
  applicationPurchase    : '/application/purchase/',
  applicationRefinance   : '/application/refinance/',
  autoLoan               : '/auto-loan/',
  autoLoanBasic          : '/auto-loan-basic/',
  autoLoanInquiry        : '/auto-loan-inquiry/',
  autoPrequal            : '/auto-prequal/',
  autoPrequalEdit        : '/auto-prequal/edit',
  autoPrequalRenew       : '/auto-prequal/renew/',
  autoPrequalWelcome     : '/auto-prequal-welcome/',
  branch                 : '/branch/',
  branchAuto             : '/branch/auto/',
  branchCommercial      : '/branch/commercial/',
  branchCommercialLease : '/branch/commercial/lease/',
  branchConsumer         : '/branch/consumer/',
  branchHomeEquity       : '/branch/home-equity/',
  branchLendingOption    : '/branch/lending-option/',
  branchMortgage         : '/branch/mortgage/',
  branchOtherVehicle     : '/branch/other-vehicle/',
  branchPersonalLoan     : '/branch/personal-loan/',
  branchSmallBusiness    : '/branch/small-business/',
  broker                 : '/broker/',
  closingCostsPurchase   : '/closing-costs/purchase/',
  closingCostsRefinance  : '/closing-costs/refinance/',
  commercial             : '/commercial/',
  commercialBridgeLoan   : '/commercial/bridge-loan/',
  commercialBusinessLoan : '/commercial/business-loan/',
  commercialEquipment      : '/commercial/equipment/',
  commercialLeaseAgFacilities : '/commercial/lease-ag-facilities/',
  commercialLeaseEquipment    : '/commercial/lease-equipment/',
  commercialLeaseMunicipal    : '/commercial/lease-municipal/',
  commercialPurchase       : '/commercial/purchase/',
  commercialRefinance    : '/commercial/refinance/',
  commercialRenew        : '/commercial/renew/',
  commercialVehicle      : '/commercial/vehicle/',
  contact                : '/contact/',
  creditBooster          : '/credit-booster/',
  creditCard             : '/credit-card/',
  employeeReferral       : '/*/referral/:loanOfficerUsername?',
  financialStatement     : '/financial-statement/',
  homeEquity             : '/home-equity/',
  homeEquityTurboWelcome : '/home-equity-turbo-welcome/',
  homeEquityInquiry      : '/home-equity-inquiry/',
  homeEquityRates        : '/home-equity-rates/',
  homeEquityTurbo        : '/home-equity-turbo/',
  insuranceQuote         : '/insurance-quote',
  loanOfficer            : '/loan-officer/',
  otherVehicle           : '/ov-loan/',
  otherVehicleBasic      : '/ov-loan-basic/',
  otherVehicleInquiry    : '/ov-loan-inquiry/',
  overdraftProtection    : '/overdraft-protection/',
  personalLoan           : '/personal-loan/',
  personalLoanInquiry    : '/personal-loan-inquiry/',
  prefill                : '/prefill',
  purchase               : '/purchase/',
  purchaseTurbo          : '/purchase-turbo/',
  refinance              : '/refinance/',
  refinanceTurbo         : '/refinance-turbo/',
  reverse                : '/reverse/',
  resume                 : '/resume/:type?/:uuid?/:hash?',
  root                   : '/',
  sbLineOfCredit         : '/small-business/line-of-credit/',
  sbTerm                 : '/small-business/term/',
};
